module.exports = '<svg width="32" height="32" viewBox="0 0 200 200"><path d="M5 0h190a5 5 0 0 1 5 5v190a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5zm95 10v180h90V10h-90z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/compare-1.js
// module id = 1083
// module chunks = 14